import React from 'react';
import PropTypes from 'prop-types';
import RegistryCollectionItemRow from './RegistryCollectionItemRow';

const GIFT_CARD_TYPE = 'GIFT_CARD';
const RegistryGrid = ({ collection, collectionItems, onAddToCart, onShowProduct }) => {
  if (collectionItems.length === 0) return null;

  return (
    <div className="registry-list">
      <div className="list-group">
        <div className="list-header">
          <div className="row">
            <div className="col-sm-5">{collection && collection.title}</div>
            <div className="col-sm-1">Price</div>
            <div className="col-sm-1 text-center">Requested</div>
            <div className="col-sm-2 text-center">Still <br className="visible-md-block" />Needs</div>
            <div className="col-sm-offset-1 col-sm-2" />
          </div>
        </div>
        <div className="">
          {collectionItems.length > 0 && collectionItems.map(collectionItem => (
            <div key={collectionItem.object_id || collectionItem.id} className="list-item">
              <RegistryCollectionItemRow
                collectionItem={collectionItem}
                onAddToCart={onAddToCart}
                onShowProduct={onShowProduct}
                isDefaultGiftCard={collectionItem.type === GIFT_CARD_TYPE}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

RegistryGrid.propTypes = {
  collection: PropTypes.shape({}),
  collectionItems: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired
};

export default RegistryGrid;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryList.jsx